import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=6454dac1&"
import script from "./Favorite.vue?vue&type=script&lang=ts&"
export * from "./Favorite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports